import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IProps, IDeps } from './models';
import { DataIterator as Component } from './component';

/**
 * Итератор
 * */
export const SmePartnersCommonDataIterator = createWidget<IDeps, IProps>({})(Component);
